var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.resolved)?_c('div',[_vm._t("whileWaiting"),_c('InlineLoading')],2):_c('div',[_vm._t("default",null,{"value":_vm.value})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }